/** Approximate points where platforms start cutting share-card text. These are
 * commonly cited guideline values, not hard limits, so the UI says "about". */
export const OG_LIMITS = {
  Facebook: { title: 88, description: 200 },
  "X (Twitter)": { title: 70, description: 200 },
} as const;

export function ogLengthWarnings(title: string, description: string): string[] {
  const out: string[] = [];
  for (const [platform, lim] of Object.entries(OG_LIMITS)) {
    if (title.length > lim.title) out.push(`${platform}: title is ${title.length} characters; it is usually cut off after about ${lim.title}.`);
    if (description.length > lim.description) out.push(`${platform}: description is ${description.length} characters; it is usually cut off after about ${lim.description}.`);
  }
  return out;
}

/** Returns an error message for an address that cannot be looked up, else null. */
export function validateLookupUrl(raw: string): string | null {
  const text = raw.trim();
  if (!text) return null;
  const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(text) ? text : `https://${text}`;
  let u: URL;
  try { u = new URL(withScheme); } catch { return "That doesn't look like a web address. Try something like https://yoursite.com/page."; }
  if (u.protocol !== "http:" && u.protocol !== "https:") return "Only http:// and https:// addresses can be read.";
  const host = u.hostname;
  if (!host.includes(".") || /\s/.test(text)) return "That doesn't look like a web address. Try something like https://yoursite.com/page.";
  if (/^(localhost|127\.|10\.|192\.168\.|169\.254\.|0\.0\.0\.0)/.test(host) || /^172\.(1[6-9]|2\d|3[01])\./.test(host)) return "Private or local addresses can't be read. Enter a public page.";
  return null;
}

export function normalizeLookupUrl(raw: string): string {
  const text = raw.trim();
  return /^[a-z][a-z0-9+.-]*:\/\//i.test(text) ? text : `https://${text}`;
}
